import React from "react";
import style from "../aj.module.css";

export default function Index({ onEnter }) {
  // onEnter is a callback to proceed to the dashboard
  return (
    <div className={`${style.ajBody} ${style.introScreen}`}>
      <div className={style.introBox}>
        <h1 className={style.ajHeaderH1}>
          Welcome to Epic EMR Simulation
        </h1>
        <p>
          The emergency room is overflowing with psychiatric patients. You are the psych consult.
          Hopefully you have a good knowledge of esoteric psychiatric conditions, because these aren't your normal patients.
        </p>
        <p>
          Please click below to proceed to the patient dashboard.
        </p>
        <button
          onClick={onEnter}
          className={style.ajButton}
        >
          Enter EMR
        </button>
      </div>
    </div>
  );
}
